export default "__VITE_ASSET__D$P7Pa5f__"